// extracted by mini-css-extract-plugin
module.exports = {"edit-roles__modal":"edit-roles_edit-roles__modal__1k37q","placeHolderShimmer":"edit-roles_placeHolderShimmer__1fjSp"};